/**
 * @file
 * Example of a custom script file.
 */

((Drupal, $) => {
  Drupal.behaviors.GDSSubthemeGlobal = {
    attach: (context, settings) => {
       var svgIcon = `
    <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.875503817,0.0988924563 L0.952803785,0.163475285 L8,7.21023256 L15.0471962,0.163475285 C15.2651633,-0.0544917616 15.6185577,-0.0544917616 15.8365247,0.163475285 C16.0302732,0.357223771 16.0518008,0.657976591 15.9011075,0.875503817 L15.8365247,0.952803785 L8.78976744,8 L15.8365247,15.0471962 C16.0544918,15.2651633 16.0544918,15.6185577 15.8365247,15.8365247 C15.6427762,16.0302732 15.3420234,16.0518008 15.1244962,15.9011075 L15.0471962,15.8365247 L8,8.78976744 L0.952803785,15.8365247 C0.734836738,16.0544918 0.381442331,16.0544918 0.163475285,15.8365247 C-0.0302732009,15.6427762 -0.0518008104,15.3420234 0.0988924563,15.1244962 L0.163475285,15.0471962 L7.21023256,8 L0.163475285,0.952803785 C-0.0544917616,0.734836738 -0.0544917616,0.381442331 0.163475285,0.163475285 Z"></path>
    </svg>
  `;

  $('#gds-vitted-block-id .gds-modal__close-button span.gds-icon')
    .html(svgIcon);

       $('#webform-submission-patient-h2fpef-calculator-node-2-add-form input#edit-actions-reset')
       .css(
        'background',
        'url("/lv/sirdsmazspeja/sm-skala/themes/custom/lv_sm_skala/images/03-icons-base-default-reset.png") left  no-repeat'
        );
      $("a").each(function() {
          $(this).attr("title", $(this).text().trim()),
            $(this).attr("data-it-asset") ||
            $(this).attr("data-it-exit-link") ||
            $(this).attr("data-it-button", $(this).attr("title").trim());
        }),
        $(".print-logo-holder img").attr("alt", "Boehringer Ingelheim logo"),
        setTimeout(function() {
          $(".webform-submission-patient-h2fpef-calculator-form .gds-btn").each(function() {
              $(this).attr("data-it-button", $(this).attr("value"));
            }),
            $("form .gds-form-multiple-step__form h5").replaceWith(function() {
              return $("<h3>", {
                class: this.className,
                html: $(this).html()
              });
            }),
            $('a[href*="bipdf"]').each(function() {
              var t = $(this).attr("href").split("/").pop().replace(/-/g, " ");
              $(this).attr("data-it-asset", t);
            }),
            $("a.use-ajax").each(function() {
              var t = decodeURIComponent($(this).attr("href").split("?external=").pop());
              $(this).attr("data-it-exit-link", t);
            }),
            $("a").each(function() {
              $(this).attr("data-it-asset") ||
                $(this).attr("data-it-exit-link") ||
                $(this).attr("data-it-button", $(this).attr("title").trim());
            });
        }, 2800),
        $(".gds-hero h2").remove(),
        $("img").each(function() {
          let t = $(this).attr("title"),
            i = $(this).attr("alt");
          (((void 0 !== t && "" != t) || "" == i) && void 0) || $(this).attr("title", i);
        }),
        $("#edit-actions-submit").hasClass("btn-submit-disable") && $(".display-text").hide(),
        $(".gds-form-input").change(function() {
          $("#edit-actions-submit").hasClass("btn-submit-disable") ?
            $(".display-text").hide() :
            $(".display-text").show();
        }),
        $("#edit-actions-reset").click(function() {
          $(".display-text").hide(), location.reload();
        }),
        $(".gds-heading")
        .filter(function() {
          return "" === $.trim($(this).text());
        })
        .remove(),
        $(".node-5 a[title='http://www.adobe.com/privacy/opt-out.html']")
        .attr("target", "_blank")
        .attr("rel", "noopener");
    },
  };
})(Drupal, jQuery);
